module.exports = __webpack_public_path__ + "static/media/wechat.5252503f.webp";